import type {Theme} from './Theme';

// Follow format <propertyName>:<property-value> /* <Figma variable name */
export const themeV2: Theme = {
  // Theme colors
  surface: '#FFFFFF' /* Base set (Default)/background-primary */,
  surfaceVariant: '#FFFFFF',
  onSurface: '#1A1C18' /* Figma: GFiber-GM3/sys/light/on-surface */,
  onSurfaceVariant:
    '#43493E' /* Figma: GFiber-GM3/sys/light/on-surface-variant */,
  onSurfaceVariantSecondary: '#444746',
  background: '#F5F5F5' /* Base set (Default)/background-secondary */,
  primary: '#008064' /* Base set (Default)/ui-brand */,
  onPrimary: '#FFFFFF' /* Figma: Inverted set/text-primary */,
  secondary: '#003F34' /* Baseline colors/Green/800 */,
  transparent: 'transparent' /* Figma: Base set (Default)/transparent */,
  onTransparent: '#202124' /* Figma: Base set (Default)/text-primary */,
  backgroundBrand: '#00806414' /* Base set (Default)/background-brand */,
  onBackgroundBrand: '#008064' /* Figma: Base set (Default)/ui-brand */,
  textSecondary: '#5F6368' /* GFiber-GM3/sys/light/secondary-container dark */,
  surfacePrimaryGradient:
    'linear-gradient(0deg, rgb(0 128 100 / 5%), rgb(0 128 100 / 5%)), linear-gradient(0deg, rgb(0 128 100 / 2%), rgb(0 128 100 / 2%)), #FFFFFF',
  surfaceSecondaryGradient:
    'linear-gradient(0deg, rgba(56, 106, 32, 0.12) 0%, rgba(56, 106, 32, 0.12) 100%), linear-gradient(0deg, rgba(118, 119, 114, 0.02) 0%, rgba(118, 119, 114, 0.02) 100%), #FDFDF6',
  headerBg: '#FFFFFF',
  footerBg: '#FFFFFF',

  // Brand colors
  blueCore: '#4285F4' /* Figma: Brand colors/Google Blue 500 */,
  greenCore: '#34A853' /* Figma: Brand colors/Google Green 500 */,
  redCore: '#EA4335' /* Figma: Brand colors/Google Red 500 */,
  yellowCore: '#FBBC04' /* Figma: Brand colors/Google Yellow 500 */,

  // Utilitary colors
  white: '#FFFFFF',
  black: '#000000',
  grey100: '#F1F3F4' /*Baseline colors/Grey/100 */,
  grey200: '#f0f3e8' /* Baseline colors/Grey/200 */,
  grey300: '#DADCE0' /* Baseline colors/Grey/300 */,
  grey400: '#bdc1c6' /* Baseline colors/Grey/400 */,
  grey700: '#5F6368' /* Baseline colors/Grey/700 */,
  green600: '#1E8E3E',
  grey800: '#3c4043' /* Baseline colors/Grey/800 */,
  neutral50: '#767772' /* GFiber-GM3/ref/neutral/neutral50 */,
  accountMenuBtnText: '#3c4043',
  warning: '#BA1B1B',
  warningContainer: '#FFDAD4',
  networkItemOk: '#00806414' /* Figma: Base set (Default)/background-brand */,
  // Alerts
  globalAlertInfo: '#00806414' /* Base set (Default)/background-brand */,
  onGlobalAlertInfo:
    '#43493E' /* Figma: GFiber-GM3/android/light/textColorSecondary */,
  globalAlertError: '#F9E5E5' /* GFiber-GM3/sys/light/error-container */,
  onGlobalAlertError: '#BA1B1B' /* GFiber-GM3/sys/light/error */,
  globalAlertWarning: '#FFF2B4',
  onGlobalAlertWarning: '#1A1C18' /* Figma: GFiber-GM3/sys/light/on-surface */,

  // Error related colors
  formError: '#C5221F' /* Base set (Default)/error */,
  errorRed: '#c00',
  errorIconRed: '#d32f2f',
  errorDialogBg: '#f2b8b5' /* GFiber-GM3/sys/light/error */,
  errorDialogIcon: '#b3261e' /* GM3/sys/light/error */,
  red600: '#d93025' /* Baseline colors/Red/600 */,

  // Buttons
  btnPrimaryBg: '#008064',
  btnPrimaryText: '#FFFFFF',
  btnPrimaryHoverBg: '#008064',
  btnPrimaryHoverShadow:
    '0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 2px 6px 2px rgba(0, 0, 0, 0.15)',
  btnPrimaryFocusActiveBg: '#008064',
  btnPrimaryDisabledBg: 'rgb(0 128 100 / 20%)',
  btnPrimaryDisabledText: 'rgb(245, 245, 245)',
  btnSecondaryBg: 'transparent',
  btnSecondaryText: 'rgba(31, 31, 31, 1)',
  btnSecondaryHoverBg: 'rgba(32, 33, 36, 0.08)',
  btnSecondaryFocusActiveBg: 'rgba(32, 33, 36, 0.12)',
  btnTertiaryBg: 'transparent',
  btnTertiaryText: '#005D4A',
  btnTertiaryHoverBg: '#EBF5F3',
  btnTertiaryFocusActiveBg: '#E0F0EC',
  btnCompactBg: 'transparent',
  btnCompactText: '#008064',
  btnCompactHoverText: '#008064',
  btnCompactFocusActiveText: '#008064',
  focusOutline: '#008064',
  outline: '#202124' /* Base set (Default)/ui-basic */,
  linkText: 'rgba(0, 93, 74, 1)',
  linkHoverText: 'rgba(0, 63, 52, 1)',

  //Form field colors
  formFieldBg: '#FFFFFF',
  formFieldBorder: '#DADCE0',
  formFieldOutlineFocus: '#008064',
  formFieldOutlineError: '#C5221F',
  formFieldLabel: '#5F6368',
  formFieldLabelFocus: '#008064',
  formFieldLabelError: '#C5221F',
  formFieldValue: '#202124',

  //Switch
  switchCheckedBg: 'rgba(26, 115, 232, 0.16)',

  // Navigation
  navText: '#1F1F1F',
  navTextSecondary: '#475467',
  navHoverBg: '#f2f4f7',

  // Fonts
  fontPrimary: "'GFiber Sans', 'Helvetica Neue', sans-serif",
};
